import { FC, useMemo } from 'react'

/* Assets */
import bump from '../images/increase.svg'
import checked from '../images/checked.svg'
import error from '../images/error.svg'
import clock from '../images/clock.svg'
import replaced from '../images/icons/replaced.png'
import { TransactionStatus } from '../api'

const TxStatus: FC<{ status: TransactionStatus }> = ({ status }) => {
  const statusIcon: string = useMemo(() => {
    switch (status) {
      case TransactionStatus.WAITING_TX:
        return clock
      case TransactionStatus.PENDING:
        return clock
      case TransactionStatus.PASSED:
        return checked
      case TransactionStatus.FAILED:
        return error
      case TransactionStatus.BUMPED:
        return bump
      case TransactionStatus.REPLACED:
        return replaced
    }
  }, [status])

  return <img src={statusIcon} className={'status-icon'} alt={status} title={status} />
}

export { TxStatus }
